import core from './commuCore'
const output = {}

/// /////////////////////////////名词解释//////////////////////////////////////
function AddGlossary (glossary) {
  return core.ajax(glossary, '/glossary', 'post')
}
output.addGlossary = AddGlossary

function GetGlossaryByBriefId (id) {
  return core.ajax(id, '/glossary', 'get')
}
output.getGlossaryByBriefId = GetGlossaryByBriefId

function SaveGlossary (glossary) {
  return core.ajax(glossary, '/glossary', 'put')
}
output.saveGlossary = SaveGlossary

function DeleteGlossarys (arr) {
  return core.ajax({ ids: arr }, '/glossary', 'delete')
}
output.deleteGlossarys = DeleteGlossarys

export default output
